import { useMutation, useQueryClient } from '@tanstack/react-query';

import { Workspaces } from '@air/api';
import { type Asset, type Workspace } from '@air/api/types';
import { callAirApi } from '@air/utils-api';

import { getCdnLinksListKey } from '~/hooks/api/useListCdnLinks';

export type CreateCdnLinkParams = {
  workspaceId: Workspace['id'];
  assetId: Asset['id'];
};

export const useCreateCdnLink = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: CreateCdnLinkParams) =>
      callAirApi(() =>
        Workspaces.CdnLinks.create({
          ...params,
          cdnType: 'cloudfront',
          followsDefaultVersion: true,
        }),
      ),
    onSuccess: async (_data, params) => {
      await queryClient.invalidateQueries({
        queryKey: getCdnLinksListKey({
          assetId: params.assetId,
          workspaceId: params.workspaceId,
        }),
      });
    },
  });
};
